var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42326 0.592773C2.9558 0.592773 0.151367 3.09677 0.151367 6.19277C0.151367 10.3928 6.42326 16.5928 6.42326 16.5928C6.42326 16.5928 12.6952 10.3928 12.6952 6.19277C12.6952 3.09677 9.89072 0.592773 6.42326 0.592773ZM6.42326 8.19277C5.1868 8.19277 4.1833 7.29677 4.1833 6.19277C4.1833 5.08877 5.1868 4.19277 6.42326 4.19277C7.65972 4.19277 8.66322 5.08877 8.66322 6.19277C8.66322 7.29677 7.65972 8.19277 6.42326 8.19277Z",
    fill: "#646168"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c91977550fbef2b9b89f677063305bbf.svg";
export { ForwardRef as ReactComponent };